import { useRef, useState } from 'react';
import { useAppState } from '../context/OmniboxJsonConverterContext';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { saveSetting, loadSettings, loadTechniqueSettings } from './converterHelperFunctions';
import CloseIcon from '@mui/icons-material/Close';



function AddTemplateModal() {
  const { openAddTemplate, handleCloseAddTemplate, detectedTechnique, selectedColumns, setSelectedSetting } = useAppState();
  const [nameExists, setNameExists] = useState(false);
  const [nameEmpty, setNameEmpty] = useState(false);

  const templateNameRef = useRef();

  const handleSaveNewTemplate = () => {
    const newTemplateName = templateNameRef.current.value;
    const savedTemplates = loadTechniqueSettings(detectedTechnique)['templates'];

    if (!Object.keys(savedTemplates).includes(newTemplateName)) {
      if (newTemplateName !== '') {
        saveSetting(detectedTechnique, newTemplateName, selectedColumns);
        setSelectedSetting(newTemplateName);

        handleCloseAddTemplate();
      }
      else {
        setNameEmpty(true);
      }
    }
    else {
      setNameExists(true);
    }

  }

  return (
    <Dialog
      open={openAddTemplate}
      onClose={handleCloseAddTemplate}
      PaperProps={{
        sx: {
          p: 1.5,
          width: '20%',
          minWidth: '350px',
        }
      }}
    >
      <DialogTitle 
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 0, mb: 0.5, borderBottom: '1px solid text.secondary' }}
      >
        <Typography variant='h6'>Add New Template</Typography>
        <IconButton title='Close' onClick={handleCloseAddTemplate}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, mb: 1.5 }}>
        <Box component='form' onSubmit={(e) => { e.preventDefault(); handleSaveNewTemplate(); }}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='body1' fontSize='14px' color='text.secondary' sx={{ minWidth: '35%' }}>Template Name:</Typography>
            <TextField inputRef={templateNameRef} variant='outlined' size='small' autoFocus autoComplete='off' error={nameEmpty} onChange={() => setNameEmpty(false)} fullWidth inputProps={{ sx: { fontSize: '14px' } }} />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 0 }}>
        <Button variant='contained' size='small' onClick={handleSaveNewTemplate}>Save</Button>
      </DialogActions>
      <Snackbar 
        open={nameExists}
        autoHideDuration={5000}
        onClose={() => setNameExists(false)}
        message='A template with this name already exists.'
      />
      <Snackbar
        open={nameEmpty}
        autoHideDuration={5000}
        onClose={() => setNameEmpty(false)}
        message='Template name cannot be empty.'
      />
    </Dialog>
  )
}

export default AddTemplateModal;